"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/LKFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_136)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_136`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-3 0H33V24H-3V0Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.6211 1.56494H31.365V22.393H12.6211V1.56494Z",
					fill: "#A2001D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.43506 1.56494H12.6211V22.393H-1.43506V1.56494Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.0562 0H12.6211V24H11.0562V0Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.43506 1.56494H4.81056V22.393H-1.43506V1.56494Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.81055 1.56494H11.0562V22.393H4.81055V1.56494Z",
					fill: "#FF9811"
				}),
				/* @__PURE__ */ n("path", {
					d: "M22.8387 11.0035C22.7405 10.8631 22.8387 8.34384 22.8387 8.34384C22.9019 7.82454 22.8457 7.75437 22.9089 7.54384C22.972 7.34033 23.2878 6.7298 23.2878 6.7298C23.2878 6.7298 22.8668 6.5684 22.565 6.6877C22.2633 6.807 20.8317 6.16138 20.3755 6.9263C20.0668 7.41752 18.7194 8.06314 18.6492 7.90875C18.5791 7.75437 18.2352 7.55787 18.165 7.70524C18.0948 7.85261 18.1159 8.68068 18.165 8.82805C18.2212 9.01051 18.8527 8.9684 19.0282 9.04559C19.2878 9.17191 19.8843 9.62103 19.8633 9.79647C19.8422 9.97191 18.2843 9.37542 18.165 9.48068C18.0668 9.56489 18.0317 10.407 18.1369 10.5333C18.2633 10.6807 19.7791 10.9263 19.8913 11.0596C20.0036 11.193 18.972 11.5789 19.0282 12.814C19.0773 13.8456 19.5896 14.0351 19.5896 14.0351C19.5896 14.0351 19.4212 14.2877 19.0422 14.2526C18.6071 14.2105 17.1194 13.0105 17.1194 13.0105C17.1194 13.0105 16.8738 5.36138 17.372 4.49121C17.7159 3.89472 15.7791 5.19998 15.7791 8.05612V10.5965C15.7791 11.0596 15.6808 12.1684 15.9615 12.9824C15.9615 12.9824 15.9334 16.2737 16.0668 16.4631C16.2001 16.6526 16.958 16.6175 17.1054 16.4631C17.2527 16.3088 17.1054 14.3579 17.1054 14.3579C17.6457 14.3719 18.3896 15.5859 19.3861 15.5088C20.8317 15.3965 21.4001 14.814 21.7931 15.1579C22.3615 15.6561 22.1791 16.7859 21.8212 17.3684C21.6668 17.614 20.8176 17.6982 20.7194 17.9017C20.6212 18.1052 20.7545 18.2807 20.7545 18.2807H22.8387C22.8387 18.2807 22.9369 16.8421 23.0282 16.4491C23.1194 16.0491 22.9861 15.6982 23.4422 15.7193C25.0913 15.7965 26.2352 14.6456 26.6352 15.1579C26.8598 15.4456 27.0282 17.2561 26.8668 17.4947C26.7124 17.7333 25.8983 17.6912 25.8001 17.9649C25.7019 18.2456 25.8562 18.2737 25.8562 18.2737H27.9405C27.9405 18.2737 27.9124 16.7859 28.1159 16.3298C28.3194 15.8737 28.4598 15.6 28.7685 15.1228C29.0773 14.6456 29.5615 14.021 29.5615 12.5824C29.5615 11.5859 28.9931 10.9824 28.9931 10.9824H26.2633C25.2738 10.9965 22.9369 11.1438 22.8387 11.0035ZM13.2948 2.26665C14.0457 1.52279 14.7124 2.07717 14.8527 2.41402C14.9861 2.75086 15.0001 2.98945 15.0492 3.3684C15.1124 3.85261 15.3931 4.35086 15.3931 4.35086C15.3931 4.35086 14.8948 4.08419 14.3615 4.05612C14.0317 4.03507 13.7299 4.01401 13.4071 3.88068C13.0071 3.71928 12.5861 2.97542 13.2948 2.26665ZM30.7264 2.25963C31.4773 3.00349 30.9229 3.67717 30.5861 3.81752C30.2492 3.95787 30.0106 3.96489 29.6317 4.01402C29.1475 4.07717 28.6492 4.36489 28.6492 4.36489C28.6492 4.36489 28.9089 3.86665 28.944 3.33331C28.965 3.00349 28.9861 2.69472 29.1124 2.37893C29.2668 1.97893 30.0106 1.55086 30.7264 2.25963ZM30.7334 21.6912C29.9826 22.4351 29.3159 21.8737 29.1755 21.5368C29.0422 21.2 29.0282 20.9614 28.9861 20.5824C28.9299 20.0982 28.6422 19.593 28.6422 19.593C28.6422 19.593 29.1334 19.8596 29.6738 19.8947C30.0036 19.9158 30.3054 19.9368 30.6282 20.0702C31.0282 20.2386 31.4492 20.9895 30.7334 21.6912ZM13.3159 21.6842C12.572 20.9333 13.1264 20.2666 13.4633 20.1263C13.8001 19.993 14.0387 19.9789 14.4176 19.9298C14.9019 19.8666 15.4001 19.5859 15.4001 19.5859C15.4001 19.5859 15.1334 20.0842 15.1054 20.6175C15.0843 20.9473 15.0633 21.2491 14.9299 21.5719C14.7685 21.9719 14.0247 22.4 13.3159 21.6842Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M28.3615 11.3965C28.3615 11.3965 28.8878 11.2141 28.9509 10.2667C28.993 9.6632 27.5615 9.1439 26.2141 9.45969C24.8316 9.78249 23.8281 9.24214 23.8281 8.43513C23.8281 6.82811 25.9123 7.29828 26.558 7.64214C27.1965 7.986 28.6422 9.29127 29.0211 8.30179",
					stroke: "#FFDA44",
					strokeWidth: .421053,
					strokeMiterlimit: 10
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_136`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as LKFlag };
